// This import loads the firebase namespace along with all its type information.
import Log from './log-model'

export async function load_logs(): Promise<Log[]> {
  throw 'Not implemented'
}

export async function delete_log(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_log(): Promise<Log> {
  throw 'Not implemented'
}
